import { ROUTE_PATH } from '@shared/constants/route-path.enum';
import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { MdcBox } from 'ids-wc/dist/react/components';
import styles from './Tabbar.module.css';
import { TabbarItem } from './TabbarItem.component';

export const Tabbar = () => {
  const { t } = useTranslationHelper('tabbar');

  return (
    <MdcBox display="flex" justifyContent="around" className={styles.tabbar}>
      <TabbarItem title={t('home')} icon="home" link={ROUTE_PATH.ROOT} />
      <TabbarItem title={t('services')} icon="widgets" link={ROUTE_PATH.SERVICES} />
      <TabbarItem title={t('settings')} icon="settings" link={ROUTE_PATH.SETTINGS} />
    </MdcBox>
  );
};
